"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTooltip = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
exports.MuiTooltip = {
    styleOverrides: {
        tooltip: __assign(__assign({}, global_1.typography.regular12), { color: colors_1.colors.Text, backgroundColor: colors_1.colors.White, borderRadius: "4px", lineHeight: "16px", boxShadow: "0px 0px 16px rgba(0,0,0,0.24)" }),
        arrow: {
            color: colors_1.colors.White,
        },
    },
};
//# sourceMappingURL=tooltip.js.map